import { createAsyncTypes } from 'utils/ActionCreator'

export const FETCH_RESOURCES_ASYNC = createAsyncTypes('FETCH_RESOURCES', 'Resources')
